import React from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  {
    to: "/admin-dashboard",
    label: "Home",
    icon: "icon-Layout-4-blocks",
    isActive: (pathname) => pathname === "/admin-dashboard",
  },
  {
    to: "/view-doctors",
    label: "Doctors",
    icon: "icon-Barcode-read",
    isActive: (pathname) => pathname === "/view-doctors",
  },
  {
    to: "/view-cases?r_type=patient",
    label: "Cases",
    icon: "icon-Compiling",
    isActive: (pathname) => pathname === "/view-cases",
  },
  {
    to: "/bp-reports?r_type=all",
    label: "Reports",
    icon: "icon-Settings-1",
    isActive: (pathname) => pathname === "/bp-reports",
  },
];

export default function AdminBottomNav() {
  const { pathname } = useLocation();

  return (
    <nav className="admin-bottom-nav" aria-label="Admin navigation">
      {NAV_ITEMS.map((item) => {
        const active = item.isActive(pathname);

        return (
          <Link
            key={item.to}
            to={item.to}
            className={`admin-bottom-nav__item${active ? " is-active" : ""}`}
            aria-current={active ? "page" : undefined}
            onClick={() => document.body.classList.remove("sidebar-open")}
          >
            <i className={item.icon}>
              <span className="path1"></span>
              <span className="path2"></span>
            </i>
            <span className="admin-bottom-nav__label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
